import React, {Component} from 'react';
import logo from '../images/logo.png';
import '../css/Header.css';

class Header extends Component {
    render() {
        return (
            <header>
                <img src={logo} alt="areamultiservice" className="homeHeader"/>
            </header>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/header/js/Header.js